export const CUSTOM_VARIABLES = {
    siteName: 'Manager',
};
export const USER_ID = 'clientSideUserId';
export default {
    CUSTOM_VARIABLES,
    USER_ID,
};
//# sourceMappingURL=config.constants.js.map